'use strict';
var dynamic = (function () {
    function dynamic($compile) {
        this.$compile = $compile;
        this.replace = true;
        this.restrict = 'A';
    }
    dynamic.prototype.link = function (scope, element, attrs) {
        var _this = this;
        scope.$watch(attrs.dynamic, function (html) {
            element.html(html);
            _this.$compile(element.contents())(scope);
        });
    };
    dynamic.factory = function () {
        var directive = function ($compile) { return new dynamic($compile); };
        directive.$inject = ['$compile'];
        return directive;
    };
    return dynamic;
}());
angular
    .module('application')
    .directive('dynamic', dynamic.factory());

//# sourceMappingURL=dynamic.js.map
